import { apiEndPoint } from "./endPoint";

export const assistantWithCreateThread = async (
  token: string,
  assistantId?: string
) => {
  let url = `${apiEndPoint}/assistantWithCreateThread`;

  if (assistantId) {
    url = url + `/${assistantId}`;
  }

  const message = "こんにちは";
  const data = {
    message: message,
  };

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });

    if (response.ok) {
      const responseData = await response.json();
      console.log(responseData);
      //   const responseMessage: messageData = {
      //     role: "assistant",
      //     content: responseData.message,
      //   };

      return responseData;
    } else {
      throw new Error("Failed to fetch");
    }
  } catch (err) {
    console.error("Error:", err);
    return {
      role: "error",
      content: "エラーが発生したようです。初めからやり直してください。",
    };
  }
};
